export enum DialogView {
    Content,
    Map,
}
